class WaitlistGuideMobile extends HTMLElement {
constructor() { 
    super();
    this.content = this.querySelector(".waitlist-guide__inner");
    this.currentTriggerBtn = null;

    this.handleClickOutside = (e) => {
        const path = e.composedPath(); 
        if (!path.includes(this.content)) return; 
    };

    this.handleEsc = (e) => {
      if (e.key === "Escape") this.close();
    };
  }

  connectedCallback() {
    this.closeButton = this.querySelector(".waitlist-guide__close");
    if (this.closeButton) {
      this.closeButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.close();
      });
    }

    document.addEventListener("click", this.handleClickOutside);

    this.addEventListener("click", (e) => {
        const option = e.target.closest('.product-form__option-value[name="waitlist_vid"]');
        if (!option) return;
        e.stopPropagation();
        // Remove active state from all
        this.querySelectorAll('.product-form__option-value[name="waitlist_vid"]').forEach((el) => {
            el.classList.remove("is-active");
        });
        option.classList.add("is-active");
    });

    document.addEventListener("waitlist-guide-mobile:open", (e) => {
      this.currentTriggerBtn = e.detail.triggerBtn;
      this.open();
      this.syncVariantFromProductForm(this.currentTriggerBtn);
    });


  // Waitlist form submit
  const submitBtn = document.getElementById("waitlist_submit_mobile");
  const emailInput = document.getElementById("waitlist_email_mobile");
  const consentBox = document.querySelector(".waitlist-guide__consent-mobile");
  const waitlistModal = document.querySelector("waitlist-guide-mobile");
  const messageBox = document.querySelector("#waitlist_message_mobile");

  const waitlistInputs = waitlistModal.querySelectorAll("input, textarea");

    waitlistInputs.forEach((input) => {
    input.addEventListener("input", (e) => {
        e.stopPropagation();
    });

    input.addEventListener("change", (e) => {
        e.stopPropagation();
    });
  });

  consentBox.addEventListener("change", (e) => {
    e.stopPropagation();
  });

  if (submitBtn) {
    submitBtn.addEventListener("click", async (e) => {
      e.preventDefault();

      const activeOption = waitlistModal.querySelector('.waitlist-form__size .product-form__option-value.is-active');
      let variantId = activeOption?.dataset.valueid;
      const productId = waitlistModal.dataset.productId;
      const firstVariantId = waitlistModal.dataset.variantId;

      const klaviyoListId = window.theme?.klaviyo_list_id_waitlist;
      if (!variantId) {
        variantId = firstVariantId;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value))
        return alert("Please enter a valid email.");
      if (typeof BIS === "undefined")
        return alert("Waitlist service not ready.");

      const email = emailInput?.value.trim();
      // Subscribe to Klaviyo drawer list if consent is given
      if (klaviyoListId) {
        try {
          const params = new URLSearchParams();
          params.append('g', klaviyoListId);
          params.append('email', email);
          params.append('a', 'VvnvnV');
          params.append('$fields', '$consent');
          params.append('signup_source', 'waitlist_drawer');
          if (productId) params.append('product_id', productId);
          if (variantId) params.append('variant_id', variantId);

          const response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params.toString(),
          });

          if (response.ok) {
            console.log('Added to Klaviyo drawer list');
          } else {
            const text = await response.text();
            console.warn('Klaviyo request failed:', text);
          }
        } catch (error) {
          console.error('Klaviyo subscription failed:', error);
        }
      }

      BIS.create(emailInput.value.trim(), variantId, productId)
        .then((data) => {
          if (data.status === "OK") {
            emailInput.value = "";
            if (consentBox) consentBox.checked = false;
            waitlistModal.querySelector(".waitlist-guide__content").style.display = "none";
            messageBox.textContent = window.theme.localeStrings.product.thank_you_message,
            messageBox.style.display = "flex";
            waitlistModal.updateTriggerButton(window.theme.localeStrings.product.added_to_waitlist);
          } else {
            waitlistModal.querySelector(".waitlist-guide__content").style.display = "none";
            messageBox.textContent = window.theme.localeStrings.product.error_message;
            messageBox.style.display = "flex";
          }
        })
        .catch((err) => {
          messageBox.textContent = "Something went wrong. Please try again later.";
          console.error(err);
        });
    });
  }

    document.addEventListener("keydown", this.handleEsc);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener("keydown", this.handleEsc);
  }

  open() {
    if (this.hasAttribute("open")) return;

    this.style.display = "block";
    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      this.classList.add("is-collapsible-open");
      
      let dimmer = document.querySelector(".waitlist-dimmer");
      if (!dimmer) {
        dimmer = document.createElement("div");
        dimmer.className = "waitlist-dimmer";
        document.body.appendChild(dimmer);
        dimmer.addEventListener("click", () => this.close());
      }

      dimmer.classList.add("is-active");
      window.lockScroll(this);
      document.body.style.position = "fixed";
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";

      this.returnFocusEl = document.activeElement;
      window.trapFocus(this, this.closeButton);
    });
  }

  close() {
    if (!this.hasAttribute("open")) return;
    this.removeAttribute("open");
    this.classList.remove("is-collapsible-open");
    this.style.display = null;
    const dimmer = document.querySelector(".waitlist-dimmer");
    if (dimmer) dimmer.classList.remove("is-active");
    const scrollY = document.body.style.top;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.overflow = "";
    document.body.style.width = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);

    window.removeTrapFocus(this.returnFocusEl);
    window.unlockScroll(this);
  }

  updateTriggerButton(text) {
    if (this.currentTriggerBtn) {
      this.currentTriggerBtn.textContent = text;
      this.currentTriggerBtn.disabled = true;
    }
  }

  syncVariantFromProductForm(triggerBtn) {
    const selectedVariantId = triggerBtn.dataset.variantId;
    if (!selectedVariantId) return;

    // Only target radios inside this waitlist guide modal
    const radioInputs = this.querySelectorAll('.waitlist-form__size [name="waitlist_vid"]');
    
    let found = false;
    radioInputs.forEach((radio) => {
        const valueId = radio.dataset.valueid;
      if (valueId === selectedVariantId) {
        // Set both property and attribute
        radio.classList.add("is-active");
        found = true;
      } else {
        radio.classList.remove("is-active");
      }
    });

    if (!found) console.warn("No matching radio found for variant ID:", selectedVariantId);
  }
}

// Register after DOM ready
document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("waitlist-guide-mobile")) {
    customElements.define("waitlist-guide-mobile", WaitlistGuideMobile);
  }

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest(".waitlist-guide__trigger-mobile");
    if (!trigger) return;

    e.preventDefault();
    document.dispatchEvent(new CustomEvent("waitlist-guide-mobile:open", {
      detail: { triggerBtn: trigger }
    }));
  });

});